import { render, staticRenderFns } from "./best-table.component.vue?vue&type=template&id=12acc138&scoped=true"
import script from "./best-table.component.vue?vue&type=script&lang=js"
export * from "./best-table.component.vue?vue&type=script&lang=js"
import style0 from "./best-table.component.vue?vue&type=style&index=0&id=12acc138&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12acc138",
  null
  
)

export default component.exports